import {useMemo} from 'react';

import {TFactors} from '../../../model/types';
import {createForecastCommentsFormFields} from '../edit-modal.utils';

/**
 * Хук для получения динамических полей формы
 *
 * @param factors - Массив факторов из данных бэкенда
 * @param isNewRequest - Флаг, что запрос в статусе "Новый" (status = false)
 *
 * @returns Мемоизированная конфигурация полей формы
 */
export const useForecastCommentsFormFields = (factors: TFactors[], isNewRequest: boolean) =>
    useMemo(() => createForecastCommentsFormFields(factors, isNewRequest), [factors, isNewRequest]);
